<app-header></app-header>
<div class="mainwrapper">
  <div class="new-container" *ngIf="!isLoading && chartDetail">
    <header class="detail-header">
      <div>
        <a (click)="goBack()" class="back-link">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor"
            class="icon-sm"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M10.5 19.5L3 12m0 0l7.5-7.5M3 12h18"
            />
          </svg>
          Back to Library
        </a>
        <h1
          class="header-title"
          [innerHTML]="chartDetail.title | ingressIconPipe"
        ></h1>
      </div>
      <div class="header-actions">
        <!-- <button class="btn btn-secondary">Edit</button> -->
        <button (click)="toggleModal(true)" class="btn btn-primary">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="currentColor"
            class="icon-sm"
          >
            <path
              d="M21.426 11.074-8-8A1 1 0 0 0 12 4v3.535A8.508 8.508 0 0 0 3.5 20.035a1 1 0 0 0 1.956.329A6.508 6.508 0 0 1 12 13.535V17a1 1 0 0 0 1.426.895l8-8a1 1 0 0 0 0-1.79Z"
            />
          </svg>
          Share
        </button>
      </div>
    </header>

    <div class="metadata-bar glass-card">
      <div class="metadata-item">
        <label>Location</label>
        <p>{{ chartDetail.location }}</p>
      </div>
      <div class="metadata-item">
        <label>Event Time</label>
        <p>{{ chartDetail.timestamp }}</p>
      </div>
      <div class="metadata-item">
        <label>Period</label>
        <p>{{ chartDetail.period }}</p>
      </div>
      <div class="metadata-item">
        <label>Author</label>
        <p>{{ getAuthorDetail(chartDetail.author) }}</p>
      </div>
      <div class="metadata-item">
        <label>Creating Date</label>
        <p>{{ getFormattedDate(chartDetail.createdAt) }}</p>
      </div>
      <div class="metadata-item">
        <label>Importance</label>
        <p class="importance-level">
          <span
            class="status-dot"
            [ngClass]="chartDetail.importance.color"
          ></span>
          {{ chartDetail.importance.level }}
        </p>
      </div>
    </div>

    <div class="main-content-grid">
      <div class="interpretation-content prose-custom">
        <h2 class="section-title">System Interpretation</h2>
        <p
          class="intro-paragraph"
          [innerHTML]="chartDetail.interpretation.intro | ingressIconPipe"
        ></p>
        <div class="body-content">
          <p
            *ngFor="let paragraph of chartDetail.interpretation.body"
            [innerHTML]="paragraph | ingressIconPipe"
          ></p>
        </div>
      </div>

      <aside class="analysis-sidebar">
        <div class="glass-card analysis-card">
          <h3 class="card-title">Chart Ruler</h3>
          <ul class="analysis-list">
            <li *ngFor="let item of chartDetail.chartRuler">
              <svg
                class="icon-md"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M2.25 21h19.5m-18-18v18m10.5-18v18m6-13.5V21M6.75 6.75h.75m-.75 3h.75m-.75 3h.75m3-6h.75m-.75 3h.75m-.75 3h.75M9 21v-3.375c0-.621.504-1.125 1.125-1.125h3.75c.621 0 1.125.504 1.125 1.125V21"
                />
              </svg>
              <span [innerHTML]="item.text | ingressIconPipe"></span>
            </li>
          </ul>
        </div>
        <div class="glass-card analysis-card">
          <h3 class="card-title">Challenges and Strengths</h3>
          <ul class="analysis-list">
            <li *ngFor="let item of chartDetail.challengesAndStrengths">
              <svg
                class="icon-md"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M2.25 21h19.5m-18-18v18m10.5-18v18m6-13.5V21M6.75 6.75h.75m-.75 3h.75m-.75 3h.75m3-6h.75m-.75 3h.75m-.75 3h.75M9 21v-3.375c0-.621.504-1.125 1.125-1.125h3.75c.621 0 1.125.504 1.125 1.125V21"
                />
              </svg>
              <span [innerHTML]="item.text | ingressIconPipe"></span>
            </li>
          </ul>
        </div>
        <div class="glass-card analysis-card">
          <h3 class="card-title">Tags</h3>
          <div
            class="tags-container"
            *ngIf="
              chartDetail?.tags && chartDetail.tags.length > 0;
              else noSector
            "
          >
            <span
              *ngFor="let tag of chartDetail.tags"
              class="tag"
              (click)="goToTag(tag)"
              [innerHTML]="tag | ingressIconPipe"
            >
            </span>
          </div>

          <ng-template #noSector>
            <div class="no-sector">No sector found</div>
          </ng-template>
          <div
            class="chart-massage"
            *ngIf="chartDetail?.tags && chartDetail.tags.length > 0"
          >
            *Click a tag to view other charts with the same tag.
          </div>
        </div>
        <div class="glass-card analysis-card">
          <h3 class="card-title">This Chart is Focused On:</h3>
          <div
            class="tags-container"
            *ngIf="
              chartDetail?.sector_focus && chartDetail.sector_focus.length > 0;
              else noSector
            "
          >
            <span
              *ngFor="let tag of chartDetail.sector_focus"
              class="tag"
              (click)="goToSector(tag)"
              [innerHTML]="tag | ingressIconPipe"
            >
            </span>
          </div>

          <ng-template #noSector>
            <div class="no-sector">No sector found</div>
          </ng-template>

          <div
            class="chart-massage"
            *ngIf="
              chartDetail?.sector_focus && chartDetail.sector_focus.length > 0
            "
          >
            *Click a tag to view other charts with the same tag.
          </div>
        </div>
      </aside>
    </div>

    <section class="related-insights">
      <h2 class="section-title">Related Insights</h2>
      <div class="related-grid">
        <a
          *ngFor="let insight of relatedInsights"
          class="related-card glass-card"
          (click)="registerClick(insight._id)"
        >
          <div class="related-card-header">
            <!-- svg omitted for brevity -->
            <span class="related-card-type">{{ insight.type }}</span>
          </div>
          <h3 class="related-card-title">{{ insight.title }}</h3>
          <p class="related-card-description">{{ insight.description }}</p>
          <div class="chart-sector-header" *ngIf="insight.sector_focus?.length">
            This Chart Focused On :
          </div>
          <div class="chart-sectors" *ngIf="insight.sector_focus?.length">
            <!-- Show first 2 -->
            <span
              class="sector"
              *ngFor="
                let sector of insight.sector_focus | slice : 0 : 2;
                let i = index
              "
            >
              {{ sector
              }}<span *ngIf="i < 1 && insight.sector_focus.length > 2">, </span>
            </span>

            <!-- +X other -->
            <span
              *ngIf="insight.sector_focus.length > 2"
              class="toggle"
              (click)="openPopover(insight, $event)"
            >
              + {{ insight.sector_focus.length - 2 }} other
            </span>
          </div>
          <div class="time-period-div">
            <div class="event-time-period">
              <p>Event Time:</p>
              <p>{{ insight.eventTimePeriod }}</p>
            </div>
            <div class="event-time-period">
              <p>Period:</p>
              <p>{{ insight.effective_timePeriod }}</p>
            </div>
            <div class="event-time-period">
              <p>Author Name:</p>
              <p>{{ insight.author?.[0]?.name ?? 'System Generated' }}</p>
            </div>

            <div class="event-time-period">
              <p>Author Email:</p>
              <p>{{ insight.author?.[0]?.email ?? 'System Generated' }}</p>
            </div>
          </div>
        </a>
        <div
          class="popover"
          *ngIf="activeChart"
          [style.top.px]="popoverPosition.top"
          [style.left.px]="popoverPosition.left"
          (click)="$event.stopPropagation()"
        >
          <div class="popover-content">
            <div class="popover-header">Others:</div>
            <div
              class="sector"
              *ngFor="let sector of activeChart.sector_focus | slice : 2"
            >
              {{ sector }}
            </div>
            <div
              class="toggle"
              (click)="closePopover(activeChart); $event.stopPropagation()"
            >
              Show Less
            </div>
          </div>
        </div>
      </div>

      <div #infiniteAnchor class="infinite-anchor" *ngIf="hasMore"></div>

      <!-- Skeleton Loader -->
      <div class="skeleton-loader" *ngIf="loading">
        <div class="skeleton-grid">
          <div class="skeleton-card" *ngFor="let item of [1, 2, 3]">
            <div class="skeleton-header">
              <div class="skeleton-icon"></div>
              <div class="skeleton-type"></div>
            </div>
            <div class="scaleton-middle">
              <div class="skeleton-title"></div>
              <div class="skeleton-description"></div>
              <div class="skeleton-description short"></div>
            </div>
            <div class="skeleton-time-periods">
              <div class="skeleton-time-period">
                <div class="skeleton-label"></div>
                <div class="skeleton-value"></div>
              </div>
              <div class="skeleton-time-period">
                <div class="skeleton-label"></div>
                <div class="skeleton-value"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
  <div class="loading-indicator" *ngIf="isLoading">
    <p>Loading Chart Details...</p>
  </div>
</div>
